import { useEffect } from "react";
import { useRouteError, useLocation, useNavigate } from "react-router";
import { TiException } from "@ti/ui-mobile";
import { LeftOutline } from "antd-mobile-icons";
import { ErrorPage, ErrorContent, ErrorTitle, ErrorDesc } from "./styles";
import { captureException } from "@/utils/sentryUtils";
import dayjs from "dayjs";

function ErrorBoundary() {
  const location = useLocation();

  const navigate = useNavigate();

  // react-router 类型有问题
  const { message } = useRouteError() as {
    message: string;
  };

  useEffect(() => {
    if (message) {
      captureException(message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  const Title = (
    <div>
      <ErrorTitle>页面遇到一些小问题</ErrorTitle>
      <ErrorDesc>Path:{location.pathname}</ErrorDesc>
      <ErrorDesc>Error:{message}</ErrorDesc>
      <ErrorDesc>Time:{dayjs().format("YYYY-MM-DD HH:mm:ss")}</ErrorDesc>
    </div>
  );

  return (
    <ErrorPage>
      <LeftOutline fontSize={24} onClick={goBack} />
      <ErrorContent>
        <TiException.Error title={Title} />
      </ErrorContent>
    </ErrorPage>
  );
}

export default ErrorBoundary;
